import React from 'react';
import { useAliveController } from 'react-activation';
import Login from '@/layout/components/Login';
import ForgetPassword from '@/views/user/pages/forget/entry';
import { getCookie } from '@lhb/cache';
import { deepCopy, matchQuery } from '@lhb/func';
import { keepRoutes } from './keep-alive-config';
import { isSource } from '@/common/utils/ways';
// import { message } from 'antd';
let locationFrom: any = {
  pathname: null,
  search: null,
};
// 路由守卫
function routerAfterEach(from: any, to: any, clearAlive, routeList) {
  const meta = routeList.find((item) => {
    return item.path === to.pathname;
  })?.meta || {};
  let title = meta.title;
  if (!title && !window.__POWERED_BY_QIANKUN__) {
    // process.env.NODE_ENV === 'development' && message.error('为了方便数据采集，请添加title！');
  } else {
    if (meta.dynamicWithName) {
      let name = meta.name;
      const metaName = matchQuery(to.search, 'metaName');
      if (metaName) {
        name = metaName;
      }
      title += name;
    }
    document.title = `LCN-${title}`;
  }
  if (from?.pathname && to?.pathname) {
    const needClear = keepRoutes.every(item => {
      const matching = !item.formPathname.includes(from.pathname) || !item.toPathname.includes(to.pathname);
      const matchingReverse = !item.formPathname.includes(to.pathname) || !item.toPathname.includes(from.pathname);
      return matching && matchingReverse;
    });
    needClear && clearAlive();
  }
  if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
  // 先发送离开页面的信息 再上传进入页面的信息
    window.LHBbigdata.spa.beforeRouteLeave()(to, from);
    window.LHBbigdata.spa.beforeRouteEnter()(to, from);
  }
  isSource() && window.parent.postMessage({ type: 'changeRouter', data: to.pathname }, `${process.env.LHB_URL}`);
}

const RouterControl: React.FC<{
  locationTo: any,
  isOpen: boolean,
  routeList: any[],
  setDismissLogin:any
}> = ({ children, locationTo, isOpen, routeList, setDismissLogin }) => {
  const { clear } = useAliveController();
  if (locationTo.pathname !== locationFrom.pathname || locationTo.search !== locationFrom.search) {
    // fullPath完全改变才会触发
    routerAfterEach({
      ...locationFrom,
      fullPath: locationFrom.pathname ? locationFrom.pathname + locationFrom.search : '/',
      path: locationFrom.pathname || '/',
    }, {
      ...locationTo,
      fullPath: locationTo.pathname + locationTo.search,
      path: locationTo.pathname,
    }, clear, routeList);
  }
  // 提前备份location数据
  const location = {
    to: locationTo,
    from: locationFrom,
  };
  locationFrom = deepCopy(locationTo);

  const token = getCookie('kunlun_token');
  if (process.env.NODE_ENV !== 'development' && !token && !isOpen) { // 如果不是本地开发，就跳转到kunlun项目
    window.location.href = `${process.env.KUNLUN_URL}?origin=${encodeURIComponent(window.location.href)}`;
    return <></>;
  }
  return (
    <>
      {(token || isOpen) ? (
        React.Children.map(children, (child) => {
          return React.cloneElement(child as React.ReactElement, {
            location,
          });
        })
      ) : (
        locationTo.pathname === '/user/forget' ? <ForgetPassword/> : <Login setDismissLogin={setDismissLogin}/>
      )}
    </>
  );
};

export default RouterControl;
